import React from 'react'
import IndividualProduct from '../components/individualProduct';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductsBanner from "../components/ProductsBanner";
import WhatsAppFloatingButton from '../components/WhatsAppFloatingButton';
const Product1 = () => {


    const productData = {
        name: "Safe-Accu2",
        image: "",
        features: [
          "* Match EN ISO 15197:2015",
          "* No Coding",
          "* 0.6μL blood sample",
          "* Strip ejector",
          "* Indicator light warning"
        ],
        brochure: "/brochure.pdf"
      };
    
  return (
    <div>
        <Header/>
        <ProductsBanner
        title="Safe-Accu2"
        backgroundImage="https://skyhitmedia.in/media/drchek.jpg"
        backgrond="cover"
        height="400px"
      />
         <IndividualProduct product={productData} />
         <Footer/>
        <WhatsAppFloatingButton/>
    </div>
  )
}

export default Product1